import React from "react";
import {
  FiUsers,
  FiCreditCard,
  FiLayers,
  FiUserPlus,
  FiSliders,
  FiTerminal,
} from "react-icons/fi";

const AdminTabs = ({ activeTab, setActiveTab, studentCount = 0 }) => {
  return (
    <div className="admin-tabs-wrapper">
      <button
        type="button"
        className="admin-tab-btn"
        onClick={() => setActiveTab("students")}
        style={{
          borderBottom: activeTab === "students" ? "3px solid #ea580c" : "none",
          color: activeTab === "students" ? "#ea580c" : "#64748b",
        }}
      >
        <FiUsers size={16} /> Student Directory ({studentCount})
      </button>

      <button
        type="button"
        className="admin-tab-btn"
        onClick={() => setActiveTab("dues")}
        style={{
          borderBottom: activeTab === "dues" ? "3px solid #ea580c" : "none",
          color: activeTab === "dues" ? "#ea580c" : "#64748b",
        }}
      >
        <FiCreditCard size={16} /> Dues & Penalties Management
      </button>

      <button
        type="button"
        className="admin-tab-btn"
        onClick={() => setActiveTab("departments")}
        style={{
          borderBottom: activeTab === "departments" ? "3px solid #ea580c" : "none",
          color: activeTab === "departments" ? "#ea580c" : "#64748b",
        }}
      >
        <FiLayers size={16} /> Department Management
      </button>

      <button
        type="button"
        className="admin-tab-btn"
        onClick={() => setActiveTab("addStudent")}
        style={{
          borderBottom: activeTab === "addStudent" ? "3px solid #ea580c" : "none",
          color: activeTab === "addStudent" ? "#ea580c" : "#64748b",
        }}
      >
        <FiUserPlus size={16} /> Register New Graduate
      </button>

      <button
        type="button"
        className="admin-tab-btn"
        onClick={() => setActiveTab("settings")}
        style={{
          borderBottom: activeTab === "settings" ? "3px solid #ea580c" : "none",
          color: activeTab === "settings" ? "#ea580c" : "#64748b",
        }}
      >
        <FiSliders size={16} /> System Settings
      </button>

      <button
        type="button"
        className="admin-tab-btn"
        onClick={() => setActiveTab("logs")}
        style={{
          borderBottom: activeTab === "logs" ? "3px solid #ea580c" : "none",
          color: activeTab === "logs" ? "#ea580c" : "#64748b",
        }}
      >
        <FiTerminal size={16} /> Audit & System Logs
      </button>
    </div>
  );
};

export default AdminTabs;
